import { Box, CircularProgress, Typography } from '@mui/material';

export interface LoadingStateProps {
  /** Visible and announced text. */
  label?: string;
  /** Centre in the viewport (initial app load). */
  fullPage?: boolean;
}

/** Accessible loading indicator (§81 „klare Loading States“). */
export function LoadingState({ label = 'Wird geladen …', fullPage = false }: LoadingStateProps) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 6,
        minHeight: fullPage ? '60vh' : undefined,
      }}
    >
      <CircularProgress aria-hidden="true" />
      <Typography color="text.secondary">{label}</Typography>
    </Box>
  );
}
